var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconViewCompHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "32px",
    viewBox: "0 0 35 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_view_comp_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Devices-window:-view-options",
    transform: "translate(-1012.000000, -634.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_view_comp_hover",
    transform: "translate(1012.000000, 634.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bkgd-copy",
    fill: "#E5E5E5",
    x: 0,
    y: 0,
    width: 35,
    height: 32,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(8.000000, 9.000000)",
    fill: "#B1B1B1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.000385,0 C19.1047419,0 20,0.897060126 20,2.00585866 L20,11.9941413 C20,13.1019465 19.1125667,14 18.000385,14 L10,14 L10,0 L18.000385,0 Z M12,2 L12,12 L18.000385,12 L18.00094,11.7090504 C18.00216,10.0644416 18,2.00585866 18,2.00585866 C18,2.00073202 12,2 12,2 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2 L8,2 L8,0 L0.997030139,0 C0.446385598,0 0,0.443864822 0,1 L0,2 Z",
    id: "Line"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 6 8 6 8 4 0 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13 C0,13.5522847 0.453036308,14 0.997030139,14 L8,14 L8,12 L0,12 L0,13 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 10 8 10 8 8 0 8"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewCompHover);
export default __webpack_public_path__ + "static/media/icon_view_comp_hover.75e1c4e5bc58d6446f5850fc95683239.svg";
export { ForwardRef as ReactComponent };